import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import DeviceInformation from 'components/DeviceInformation/PractitionersDeviceInformation';
import PatientEngagement from 'containers/PatientEngagement/PatientEngagementWrapper';
import PatientInformation from 'components/PatientInformation';
import TransmissionReport from 'containers/TransmissionReport';

import EmptyPage from 'components/EmptyPage';

const EmptyReportPage = () => <EmptyPage text="reports.selectReportInSidebar" />;

const ResearcherPatientPageContent = () => (
  <Switch>
    <Redirect
      strict
      exact
      from="/patient/:id/transmission-report/"
      to="/patient/:id/transmission-report"
    />
    <Redirect strict exact from="/patient/:id" to="/patient/:id/patient-information" />
    <Route path="/patient/:id/patient-information" component={PatientInformation} />
    <Route exact path="/patient/:id/device-information" component={DeviceInformation} />
    <Route exact path="/patient/:id/engagement" component={PatientEngagement} />
    <Route exact path="/patient/:id/transmission-report" component={EmptyReportPage} />
    <Route path="/patient/:id/transmission-report/:reportId" component={TransmissionReport} />
    <Redirect to="/404" />
  </Switch>
);

export default ResearcherPatientPageContent;
